import React from 'react';

const Category = ({ item, onChangePage }) => {
  return (
    <div className="flex-1 m-2 shadow-lg rounded-md overflow-hidden relative">
      <img src={item.src} alt="image_category" className="w-full" />
      <div className="flex absolute w-full h-full left-0 top-0 items-center justify-center flex-col gap-2">
        <h2 className="text-white font-medium text-3xl drop-shadow-2xl">{item.title}</h2>
        <button className="btn" onClick={() => onChangePage('CategoryPage')}>
          See more
        </button>
      </div>
    </div>
  );
};

export default Category;
